'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const FileSaver=require('file-saver');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

PdfViewerDirective=class PdfViewerDirective extends BaseControllerBackedDirective{
get template(){
return'<h3 ng-if="controller.isIE && controller.blob">Please <a ng-click="controller.downloadPdf()">click here</a> to download your report.</h3>';
}

get textBindings(){return['pdfData','fileName']}
get controller(){return PdfViewerController}};let


PdfViewerController=class PdfViewerController{
static get $inject(){return['$timeout','$scope','$element']}
constructor($timeout,$scope,$element){
this._$timeout=$timeout;
this._$scope=$scope;
this._$element=$element;
this._alreadyInitialized=!1;

this.downloadPdf=()=>this._downloadPdf();

$scope.$watch('controller.pdfData',(newPdfData,oldPdfData)=>{

if(this._alreadyInitialized||!_.exists(this.pdfData)||this.pdfData===''){
return;
}

this._populateData();
});
}

_populateData(){
if(this._alreadyInitialized){
return;
}
this._alreadyInitialized=!0;

this._blob=b64toBlob(this.pdfData,'application/pdf',this.fileName);
this._blobObjectUrl=URL.createObjectURL(this._blob);

if(_.exists(window,'navigator.msSaveOrOpenBlob')){
this.isIE=!0;
this._downloadPdf();
return;
}

fastdom.mutate(()=>{
angular.element(this._$element).html(`<object data="${this._blobObjectUrl}" type="application/pdf"></object>`);
});
}

get blob(){
return this._blob;
}

get blobObjectUrl(){
return this._blobObjectUrl;
}

_downloadPdf(){
FileSaver.saveAs(this._blob,this.fileName);
}};


function b64toBlob(b64Data,contentType,fileName){
let sliceSize=512;

var byteCharacters=atob(b64Data);
var byteArrays=[];

for(var offset=0;offset<byteCharacters.length;offset+=sliceSize){
var slice=byteCharacters.slice(offset,offset+sliceSize);
var byteNumbers=new Array(slice.length);
for(var i=0;i<slice.length;i++){
byteNumbers[i]=slice.charCodeAt(i);
}

var byteArray=new Uint8Array(byteNumbers);
byteArrays.push(byteArray);
}

var blob=new Blob(byteArrays,{type:contentType},fileName);
return blob;
}

module.exports=PdfViewerDirective;
//# sourceMappingURL=pdfViewerDirective.js.map
